import React, { useEffect, useState } from "react";
import { useNavigate, redirect } from "react-router-dom";
import Navbar from "../../Components/Navbar";

import EmployeeMaleimage from "../../Assets/employeelistimage.svg";
import Femaleimage from "../../Assets/femaleimage.svg";
import { getAllOrgUsersLeaveHistory } from "../../api/AdminLeaveManagement/getAllOrgUsersLeaveHistory";
import { useAuthContext } from "../../hooks";
import { Button } from "react-bootstrap";
import AdminLeaveSc from "./index.sc";
import { get_all_employee_master_pto } from "../../api/LeaveManagement/get_all_employee_master_pto";
import EmployeeChart from "../../Components/Chart/AllEmployeeChart";
function AdminLeaveManagement() {
  const navigate = useNavigate();

  const auth = useAuthContext();
  const [allUserLeaveHistory, setAllUserLeaveHistory] = useState<any>([]);
  const [allEmployeePto, setAllEmployeePto] = useState<any>([]);

  const fetchAlluserDetails = async () => {
    setAllUserLeaveHistory(
      await getAllOrgUsersLeaveHistory(
        auth?.userInfo?.orgs[0]?.id,
        (auth?.userInfo?.orgs_user_id[0]).toString()
      )
    );
    console.log("leave history details fukl");
  };
  const fetchAllEmployeePto = async () => {
    setAllEmployeePto(
      await get_all_employee_master_pto(auth?.userInfo?.orgs[0]?.id)
    );
    console.log("leave history details fukl");
  };

  useEffect(() => {
    fetchAlluserDetails();
    fetchAllEmployeePto();
  }, []);
  // if(allUserLeaveHistory .length > 0 ){
  //   return navigate()
  // }
  const [searchQuery, setSearchQuery] = useState("");
  return (
    <AdminLeaveSc>
      <div className="main">
        <div className="form-group has-search">
          <input
            type="text"
            className="form-control"
            placeholder="Search Employee"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        <Button onClick={() => navigate("employeeDetails")}>
          Employee Details
        </Button>
      </div>
      <EmployeeChart employeesData={allEmployeePto} />
      {allUserLeaveHistory.length > 0 ? (
        <div className="admin-leave-conatiner">
          <div className="employee-list-container">
            <div className="profile-list">Profile</div>
            <div className="leave-details-container">
              <div className="leave-details"> Leave Details</div>
              <div className="leave-details-available">
                <div>Taken</div>
                <div>Available</div>
              </div>
            </div>
          </div>

          {allUserLeaveHistory
            ?.filter(
              (data: any) =>
                data.first_name
                  .toLowerCase()
                  .includes(searchQuery.toLowerCase()) ||
                data.last_name.toLowerCase().includes(searchQuery.toLowerCase())
            )
            .map((data: any) => {
              return (
                <div
                  key={data.org_user_id}
                  onClick={() => navigate(`${data?.org_user_id}`)}
                  className="employee-list-containers"
                >
                  <div className="profile-list ">
                    <div className="employee-name mx-2 w-100">
                      {data.first_name + "" + data?.last_name}
                    </div>
                  </div>

                  <div className="leave-details-main">
                    <div className="leave-taken">{data.taken_off_days}</div>
                    <div className="leave-available">
                      {data.available_off_days}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      ) : (
        <div>Only HR access to this module</div>
      )}
    </AdminLeaveSc>
  );
}

export default AdminLeaveManagement;
